<template>
  <section>
    <div class="box2" style="margin-top:150px;">
      <div class="header">
        <transition name="title">
          <!-- <div v-if="stage === 'dados'" key="enter" class="title">Meus dados</div>
          <div v-if="stage === 'senha'" key="register" class="title">Alterar senha</div>
          <div v-if="['remove', 'remove-online', 'remove-tickets', 'remove-confirm'].includes(stage)" key="register" class="title">Portal de Privacidade Tiketera</div> -->
        </transition>
      </div>
      <transition name="page" class="content">
        <!-- Alterar Dados -->
        <div v-if="stage === 'dados'" key="page-1" class="modal-content">
          <!-- <div class="profile-image" style="flex-shrink: 0">
            <img v-if="picture" @load="imgLoaded = true" :src="`https://graph.facebook.com/${picture}/picture?type=large`" :class="{ loaded : imgLoaded }"/>
            <i v-if="!picture" class="fas fa-user"></i>
          </div> -->
          <form @submit.prevent class="form" style="flex-shrink: 0">
            <!-- Nome -->
            <label>Nome</label>
            <input v-model="name" type="text" placeholder="O seu nome" :class="{ error : error.indexOf('name') > -1 }" style="text-transform: uppercase"/>
            <div v-if="error.indexOf('name') > -1" class="hint">Nome inválido! Precisa ser nome e sobrenome.</div>
            <!-- Email -->
            <label>E-mail</label>
            <input v-model="email" :disabled="true" type="email" placeholder="O seu email" :class="{ error : error.indexOf('email') > -1 || error.indexOf('login-exists') > -1 }"/>
            <div v-if="error.indexOf('email') > -1" class="hint">você esqueceu o e-mail</div>
            <div v-if="error.indexOf('login-exists') > -1" class="hint">Já existe um usuário cadastrado com esse e-mail</div>
            <label>CPF</label>
            <input v-model="document" :disabled="true" type="text" :class="{ error : error.includes('document') }" />
            <div v-if="error.indexOf('document') > -1" class="hint">você esqueceu de digitar o CPF</div>
            <!-- Celular -->
            <label>Celular</label>
            <input v-model="phone" type="text" placeholder="Número do celular" :class="{ error : error.indexOf('phone') > -1 }"/>
            <div v-if="error.indexOf('phone') > -1" class="hint">número de celular inválido</div>
            <label>Telegram (para ser incluido no grupo de assinantes)</label>
            <input v-model="telegram" type="text" placeholder="Usuário do Telegram" style="text-transform: lowercase;"/>
            <label>Usuário TradingView (para indicadores TradingView)</label>
            <input v-model="traddingview" type="text" placeholder="Usuário do TradingView" style="text-transform: lowercase;"/>
            <label>Chegou até o Swiss Money através:</label>
            <select v-model="fonte" :disabled="hasfonte">
              <option value="NENHUM">Nenhum</option>
              <option value="TERCIO">Trader de Mesa Proprietária</option>
              <option value="REGIS">Pra cima Traders</option>
              <!--<option value="QE">QE</option>-->
              <option value="ANDERSON">Mesa Prop Americana/Trader Funding</option>
              <!--<option value="EMANUEL">EMANUEL</option> -->
              <option value="SWISS">Swiss Money Global</option>
              <option value="OUTRO">Outro</option>
            </select>
            <label v-if="fonte === 'OUTRO'">Por favor, digite aqui</label>
            <input v-if="fonte === 'OUTRO'" v-model="newfonte" type="text" placeholder="De onde veio?" style="text-transform: uppercase;"/>
            <!-- Newsletter -->
            <label class="switch">
              <input v-model="newsletter" type="checkbox">
              <span class="slider"></span>
              <span class="text" style="color:#ccc;">Quero receber novidades</span>
            </label>
          </form>
          <form @submit.prevent class="form" style="flex-shrink: 0">
            <button @click="changeDetails" class="button-save">
              <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Atualizar</span>
            </button>
          </form>
        </div>
        <!-- Nova Senha -->
        <div v-if="stage === 'senha'" key="page-2" class="modal-content">
          <i class="fas fa-key password-icon"></i>
          <form @submit.prevent class="form">
            <label>Nova Senha</label>
            <input v-model="password1" type="password" placeholder="Com mais de 6 dígitos" :class="{ error : error.indexOf('password1') > -1 }"/>
            <div v-if="error.indexOf('password1') > -1" class="hint">senha inválida</div>
            <label>Repita</label>
            <input v-model="password2" type="password" placeholder="Digite a senha novamente" :class="{ error : error.indexOf('password2') > -1 }"/>
            <div v-if="error.indexOf('password2') > -1" class="hint">Opa, as senhas não estão iguais</div>
          </form>
          <form @submit.prevent class="form">
            <button @click="changePassword" class="button-save">
              <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Atualizar</span>
            </button>
          </form>
        </div>
        <!-- Remoção de Dados -->
        <div v-if="stage === 'remove'" key="page-3" class="modal-content">
          <form @submit.prevent class="form" style="flex-shrink: 0">
            <p>Aqui você pode exercer seus direitos previstos na LGPD (Lei Geral de Proteção de Dados) e solicitar a exclusão de seus dados pessoais.</p>
            <template v-if="nextShows.length || onlineShows.length">
              <p><strong>IMPORTANTE:</strong> Se prosseguir com a solicitação, todos os registros e dados sensíveis pertinentes ao seu usuário cadastrado na Tiketera com o e-mail <span style="color:#560070;display:inline;">{{email}}</span> serão automaticamente removidos, inclusive o(s) registro(s) de ingresso(s) de evento(s) que irá(ão) acontecer. Além disso, você não terá mais acesso à Tiketera e nem a seu(s) ingresso(s), contudo, caso necessite adquirir ingressos através da Tiketera no futuro, você deverá criar uma nova conta de usuário.</p>
              <p>Caso tenha certeza de sua decisão e deseja prosseguir e excluir seus dados pessoais e todos os demais registros pertinentes à sua conta de usuário, marque a opção "Sim, estou ciente e quero excluir meus dados pessoais." e prossiga.</p>
            </template>
            <template v-else-if="previousShows.length">
              <p><strong>IMPORTANTE:</strong> Se prosseguir com a solicitação, todos os registros e dados sensíveis pertinentes ao seu usuário cadastrado na Tiketera com o e-mail <span style="color:#560070;display:inline;">{{email}}</span> serão automaticamente removidos, inclusive registro(s) de ingresso(s) que você adquiriu de evento(s) já foram realizado(s). Além disso, você não terá mais acesso à Tiketera, contudo, caso necessite adquirir ingressos através da Tiketera no futuro, você deverá criar uma nova conta de usuário.</p>
              <p>Caso tenha certeza de sua decisão e deseja prosseguir e excluir seus dados pessoais e todos os demais registros pertinentes à sua conta de usuário, marque a opção "Sim, estou ciente e quero excluir meus dados pessoais." e prossiga.</p>
            </template>
            <template v-else>
              <p><strong>IMPORTANTE:</strong> Se prosseguir com a solicitação, todos os registros e dados sensíveis pertinentes ao seu usuário cadastrado na Tiketera com o e-mail <span style="color:#560070;display:inline;">{{email}}</span> serão automaticamente removidos e você não terá mais acesso à Tiketera, contudo, caso necessite adquirir ingressos através da Tiketera no futuro, você deverá criar uma nova conta de usuário.</p>
              <p>Caso tenha certeza de sua decisão e deseja prosseguir e excluir seus dados pessoais, marque a opção "Sim, estou ciente e quero excluir meus dados pessoais." e prossiga.</p>
            </template>
            <label class="switch" style="text-transform: none; margin: 0 0 10px">
              <input v-model="removeConfirm" type="checkbox">
              <span class="slider"></span>
              <span class="text">Sim, estou ciente e quero excluir meus dados pessoais.</span>
            </label>
            <div @click="removeNextStep" class="button-link" style="margin-bottom: 15px">Prosseguir com a exclusão de meus dados pessoais</div>
            <button @click="stage = 'dados'" type="button" class="button-save">Cancelar</button>
          </form>
        </div>
        <!-- Ingressos Online Remoção de Dados -->
        <div v-if="stage === 'remove-online'" key="page-4" class="modal-content">
          <form @submit.prevent class="form" style="flex-shrink: 0">
            <p>Notamos que você tem ingresso(s) de evento(s) online, destacado(s) abaixo, que ainda está(ão) vigente(s). Se você prosseguir com a exclusão de seus dados pessoais, você perderá definitivamente o acesso ao(s) mesmo(s), visto que você não será mais um de nossos usuários.</p>
            <p v-for="show in onlineShows" :key="show.id">
              <strong>{{ show.name }}</strong><br />
              {{ show.live ? 'Dia ' : 'Válido até ' }} {{ String(show.date).split(' ')[0] + ' às ' + String(show.date).split(' ')[1].split(':')[0] + ':' + String(show.date).split(' ')[1].split(':')[1] }}
            </p>
            <label class="switch" style="text-transform: none; margin: 10px 0">
              <input v-model="removeOnlineConfirm" type="checkbox">
              <span class="slider"></span>
              <span class="text">Sim, estou ciente que irei perder definitivamente o acesso ao(s) evento(s) acima mencionado(s)</span>
            </label>
            <div @click="removeOnlineNextStep" class="button-link" style="margin-bottom: 15px">Prosseguir com a exclusão de meus dados pessoais</div>
            <button @click="stage = 'dados'" type="button" class="button-save">Cancelar</button>
          </form>
        </div>
        <!-- Enviar Ingressos Remoção de Dados -->
        <div v-if="stage === 'remove-tickets'" key="page-5" class="modal-content">
          <form @submit.prevent class="form" style="flex-shrink: 0">
            <p>Notamos que você tem ingresso(s) de evento(s) presencial(is) vigente(s). Sugerimos que você faça o backup de seu(s) ingresso(s) agora, pois após concluir o processo, você não terá mais acesso ao(s) mesmo(s), nem mesmo poderá solicitá-lo(s) à Tiketera, visto que você não será mais um de nossos usuários.</p>
            <button @click="removeSendTickets" type="button" class="button-save" style="margin-bottom: 50px">
              <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-paper-plane'"></i><span>Enviar ingressos via e-mail</span>
            </button>
            <div @click="stage = 'remove-confirm'" class="button-link" style="margin-bottom: 15px">Prosseguir com a exclusão de meus dados pessoais</div>
            <button @click="stage = 'dados'" type="button" class="button-save">Cancelar</button>
          </form>
        </div>
        <!-- Confirma Remoção de Dados -->
        <div v-if="stage === 'remove-confirm'" key="page-6" class="modal-content">
          <form @submit.prevent class="form" style="flex-shrink: 0">
            <p>Para prosseguir com a exclusão de seus dados pessoais vinculados à conta de usuário Tiketera com o e-mail <span style="color:#560070;display:inline;">{{email}}</span>, confirme sua decisão.</p>
            <div @click="callRemove" class="button-link" style="margin-bottom: 15px;">Confirmar</div>
            <button @click="stage = 'dados'" type="button" class="button-save" style="margin-top:">
              <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Cancelar</span>
            </button>
          </form>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { update, changePass } from '../api/customer'
import { removeData } from '../api/auth'
import { removeToken } from '../../util'
import { getByShowDate } from '../api/ticket'
import { send } from '../api/mail'

export default {
  name: 'userDetail',
  props: ['change', 'customer', 'previousShows', 'nextShows', 'onlineShows'],
  data () {
    return {
      stage: this.change,
      loading: false,
      error: [],
      name: null,
      email: null,
      document: null,
      phone: null,
      newsletter: false,
      traddingview: null,
      telegram: null,
      password1: null,
      password2: null,
      picture: null,
      imgLoaded: false,
      removeConfirm: false,
      removeOnlineConfirm: false,
      hasfonte: false,
      newfonte: null,
      fonte: ''
    }
  },
  mounted () {
    document.body.style.backgroundColor = '#000'
    this.name = this.customer.name
    this.email = this.customer.login
    this.document = this.customer.document
    this.phone = this.customer.phone
    this.newsletter = this.customer.newsletter
    this.picture = this.customer.picture
    this.telegram = this.customer.telegram
    this.traddingview = this.customer.traddingview
    this.fonte = this.customer.fonte
    this.hasfonte = this.fonte ? true : false
  },
  methods: {
    async removeSendTickets () {
      try {
        this.loading = true
        for (const show of this.nextShows) {
          const tickets = await getByShowDate(show.id)
          send(this.customer.login, tickets.map(x => x.id))
        }
        this.$message.success('Ingressos enviados com sucesso', { duration: 3000 })
      } catch (error) {
        logger.error(error, this)
      } finally {
        this.loading = false
      }
    },
    removeOnlineNextStep () {
      if (this.removeOnlineConfirm) {
        if (this.nextShows.length > 0) this.stage = 'remove-tickets'
        else this.stage = 'remove-confirm'
        this.removeOnlineConfirm = false
      }
    },
    removeNextStep () {
      if (this.removeConfirm) {
        if (this.onlineShows.length > 0) this.stage = 'remove-online'
        else if (this.nextShows.length > 0) this.stage = 'remove-tickets'
        else this.stage = 'remove-confirm'
        this.removeConfirm = false
        this.removeOnlineConfirm = false
      }
    },
    async callRemove () {
      this.error = []
      try {
        this.loading = true
        await removeData()
        this.loading = false
        removeToken()
        this.$store.commit('user', null)
        this.$router.push('/')
        this.$message.success('Seus dados pessoais foram excluídos', { duration: 3000 })
      } catch (error) {
        this.loading = false
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
      }
    },
    async changePassword () {
      if (this.loading) return false
      this.loading = true
      try {
        this.error = []
        await changePass(this.password1, this.password2)
        this.$router.push('/usuario')
        this.$message.success('Senha alterada com sucesso.', { duration: 3000 })
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        // Different password
        } else if (data.error === 'Different password') {
          this.error = ['password2']
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async changeDetails () {
      if (this.loading) return false
      this.loading = true
      try {
        this.error = []
        if (this.newfonte) {
          this.fonte = String(this.newfonte).toUpperCase()
          this.hasfonte = true
        }
        await update(this.name, this.email, this.phone, this.newsletter, this.telegram, this.traddingview, this.fonte)
        this.$router.push('/usuario')
        this.$message.success('Alteração realizada com sucesso.', { duration: 3000 })
        // One Signal
        /*
        // CORDOVA
        if (process.env.CORDOVA_PLATFORM) {
          window.plugins.OneSignal.getPermissionSubscriptionState(async (status) => {
            if (status.subscriptionStatus.subscribed) {
              window.plugins.OneSignal.sendTags({
                real_name: this.name,
                first_name: this.name.split(' ')[0]
              })
              window.plugins.OneSignal.setEmail(this.email)
              window.plugins.OneSignal.setSubscription(this.newsletter)
            }
          })
        // WEB
        } else {
          const pushEnabled = window.OneSignal ? await window.OneSignal.isPushNotificationsEnabled() : null
          if (pushEnabled) {
            window.OneSignal.push(() => {
              window.OneSignal.sendTags({
                real_name: this.name,
                first_name: this.name.split(' ')[0]
              })
            })
            window.OneSignal.setEmail(this.email)
            window.OneSignal.setSubscription(this.newsletter)
          }
        }
        */
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.box2 {
  width: 540px;
  margin: 0 auto;
  padding: 20px;
  background: #1a1a1a;
  border: 1px solid #333;
  box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.5);
  border-radius: 10px;
  transition: height 1s;
}
.form label {
  color: #ccc;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}
.button-save {
  color: #fff;
  border: none;
  border-radius: 100px;
  box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  font-size: 1em;
  font-weight: 400;
  width: auto;
  height: 40px;
  padding: 0 15px;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
  i {
    margin-right: 7px;
  }
}

.divider {
  position: relative;
  width: 100%;
  margin-top: 30px;
  border-bottom: 1px solid #444;
  margin-bottom: 10px;
  &::after {
    content: attr(data-text);
    background-color: #1a1a1a;
    color: #888;
    font-size: 0.9em;
    padding: 0 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.forgot-pass {
  text-transform: uppercase;
  color: #2f55a4;
  font-size: 0.9em;
  margin-top: 15px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.profile-image {
  width: 120px;
  height: 120px;
  align-self: flex-start;
  margin: 0 auto;
  text-align: center;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: contain;
    opacity: 0;
    transform: scale(0);
    transition: opacity 0.5s, transform 0.2s;
    &.loaded {
      opacity: 1;
      transform: scale(1);
    }
  }
  i {
    width: 90%;
    height: 90%;
    border: 5px solid $secondary-color;
    border-radius: 50%;
    text-align: center;
    color: $secondary-color;
    font-size: 60px;
    line-height: 95px;
  }
}

.password-icon {
  color: $secondary-color;
  font-size: 120px;
  margin: 15px auto 0;
}

.form {
  p {
    margin-bottom: 15px;
    color: #ccc;
  }
}

.button-link {
  cursor: pointer;
  margin-top: 35px;
  text-align: center;
  color: #8d6ef4;
  text-decoration: underline;
}

input:checked + .slider {
    background-color: #8d6ef4;
}
.modal-content {
  width: 300px;
}
.form input,
.form select {
  background: #0f0f0f;
  border-color: #333;
  color: #fff;
}
.form input::placeholder {
  color: #666;
}
.form input:disabled {
  background: #1a1a1a !important;
  color: #888;
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .profile-image {
    display: none;
  }
  .password-icon {
    display: none;
  }
  .modal-content {
    width: 500px;
  }
}
</style>
